import { render, staticRenderFns } from "./project-information-archived.html?vue&type=template&id=545f10a2&"
import script from "./ProjectInformationArchived.vue?vue&type=script&lang=js&"
export * from "./ProjectInformationArchived.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInformationArchived.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports